<template>
  <v-dialog v-model="dialog" max-width="50%">
    <template v-slot:activator="{ on }">
      <v-btn icon small v-on="on">
        <v-icon small>edit</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="headline">Edit Attachment Name</v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid">
          <v-text-field
            label="Attachment Name"
            v-model="name"
            counter="128"
            :rules="nameRules"
          >
          </v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="warning" @click="dialog = false">
          <v-icon left>close</v-icon>
          Close
        </v-btn>
        <v-btn color="success" :disabled="!valid" @click="submit">
          Submit
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "AttachmentFormEdit",
  props: {
    instance: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  data() {
    return {
      valid: true,
      dialog: false,
      name: this.instance.name,
      nameRules: [
        v => !!v || "Name is required",
        v => (v && v.length <= 128) || "Name must be less than 128 characters"
      ]
    };
  },
  methods: {
    submit() {
      this.instance.constructor
        .$patch(this.instance.id, { name: this.name })
        .then(() => (this.dialog = false));
    }
  }
};
</script>
